import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { VcenterDataProviderFactory } from '../factory/VcenterDataProviderFactory';
import { VcenterBaseDataProvider } from '../dataProvider/VcenterBaseDataProvider';
import { VcenterWebComponentSchema } from '../types';

export class VcenterRepository extends BaseWebComponentRepository {
  public dataProviderFactory: VcenterDataProviderFactory;
  public dataProvider: VcenterBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new VcenterDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<VcenterWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
